export interface AppConfig {
  component: any // TODO
}

const componentsMatchingTable: Record<string, AppConfig> = {
  'booking-mask': {
    component: () => import(`@/components/app-containers/AppBookingMask.vue`),
  },
  'ui-kit': {
    component: () => import(`@/pages/UiKit.vue`),
  },
}

export const getContainerConfig = (containerKey: unknown) => {
  if (typeof containerKey !== 'string') {
    throw new Error('DB APP - missing containerKey')
  }
  return componentsMatchingTable[containerKey]
}
